import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import { LuPackageSearch} from "react-icons/lu";
import {SiSearxng} from "react-icons/si";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {HiOutlineQrcode} from "react-icons/hi";
import {FaEye} from "react-icons/fa";

function SearchProduct() {

    const [code, setCode] = React.useState('');
    const [isLoaded, setIsLoaded] = React.useState(true);
    const [data, setData] = React.useState(null);
    const onButtonClick = () => {
        if(code.length < 13) {
            toast.error('کد باتری را کامل وارد کنید')
            return false
        }
        setIsLoaded(false);
        API.searchProduct(code)
            .then((response) => {
                setData(response.data)
                setIsLoaded(true);

            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }


    return (
        <React.Fragment>
            <Header/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Navbar page="battery"/>

            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <SiSearxng className='ms-2' />
                    جستجوی باتری
                    </h1>

                </div>

                <section className="section">
                    <div className="row">

                        <div className="col-12">

                            <div className="card">
                                <div className="card-body py-4">
                                   <div className="row">
                                       <div className="col-md-6">
                                           <div className="form-floating mb-3">
                                               <input type="number" className="form-control text-center" id="floatingInput" placeholder="کد"
                                               autoFocus={true}
                                                      value={code}
                                                      onChange={(val) => {
                                                          setCode(val.target.value)
                                                      }}
                                               />
                                                   <label htmlFor="floatingInput">کد باتری</label>
                                           </div>
                                       </div>
                                       <div className="col-md-2">
                                           &nbsp;
                                       </div>
                                       <div className="col-md-4 pt-2">
                                           <button className="btn btn-warning w-100 py-2"
                                           onClick={onButtonClick}
                                           >
                                               جستجو
                                                <LuPackageSearch className='float-start mt-1' />
                                           </button>
                                       </div>
                                   </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-12">

                            <div className="card">
                                {
                                    data &&
                                    <div className="card-body py-4">

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode />
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                کد یکتای باتری:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.code}
                                            </div>
                                        </div>


                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode />
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                برند:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.brand}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode />
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                آمپراژ:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.properties[0]?.amperage}
                                                <span className='me-2 text-small-2 text-muted'>
                                                آمپر
                                            </span>
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode />
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                وضعیت:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2"
                                                 style={{color: data?.status?.color}}
                                            >
                                                {data?.status?.title}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode />
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                تاریخ پایان گارانتی:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.warranty_end_date}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode />
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                سفارش مربوطه:
                                            </div>
                                            {
                                                data?.order?.id &&
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2"
                                                 onClick={
                                                     () => {
                                                         window.location.assign(`orders/${data?.order?.id}`)
                                                     }
                                                 }
                                                 role='button'
                                            >
                                                <FaEye className='mx-2 text-big-2 text-primary' />
                                                {data?.order?.tracking_code}
                                            </div>
                                            }
                                        </div>
                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode />
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                کد پالت:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.pallet_code}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode />
                                            </div>
                                            <div className=" col-11 text-small-2">
                                                اطلاعات فنی باتری:
                                            </div>
                                            <div className="col-2">
                                                &nbsp;
                                            </div>
                                            <div className="col-10 px-4 py-2 text-big-2 text-center">


                                            <span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                       اسید:
                                                &nbsp;
                                                {data?.properties[0]?.acid}
                                   </span>
                                                <span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                       تیپ باتری:
                                                    &nbsp;
                                                    {data?.properties[0]?.battery_type}
                                   </span>
                                                <span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                       نوع بازکاری:
                                                    &nbsp;
                                                    {data?.properties[0]?.battery_type}
                                   </span>
                                                <span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                        نوع صفحه:
                                                    &nbsp;
                                                    {data?.properties[0]?.sheet}
                                   </span>
                                                <span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                       نوع سپراتور:
                                                    &nbsp;
                                                    {data?.properties[0]?.separator}
                                   </span>


                                            </div>
                                        </div>

                                    </div>
                                }
                            </div>

                        </div>

                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default SearchProduct;